$(() => {
  new Vue({
    el: document.querySelector(".v-manage-loans-controller"),
  });
});
